
import { gaEventTracker, EVENT_CATEGORIES, EVENT_NAMES, EVENT_LABELS } from '@/utils'


class GAEventTracker {
  emailCTA: HTMLAnchorElement | null
  phoneCTA: HTMLAnchorElement | null
  submitCTA: HTMLButtonElement | null
  thanksWhatsappCTA: HTMLAnchorElement | null
  waWidgetSendButton: HTMLElement | null

  constructor() {
    this.emailCTA = document.getElementById('email-cta') as HTMLAnchorElement
    this.phoneCTA = document.getElementById('phone-cta') as HTMLAnchorElement
    this.thanksWhatsappCTA = document.getElementById('thanks-whatsapp-cta') as HTMLAnchorElement
    this.submitCTA = document.getElementById('submit-cta') as HTMLButtonElement
    this.waWidgetSendButton = document.querySelector('.wa-chat-box-content-send-btn') as HTMLElement
    this.bindEvents()
  }

  submitClick() {
    this.registerGAEvent(EVENT_NAMES.CONTACT_FORM_SUBMISSION, EVENT_LABELS.CONTACT_PAGE, EVENT_CATEGORIES.CONTACT_FLOW)
  }
  emailClick() {
    this.registerGAEvent(EVENT_NAMES.CLICK_EMAIL, EVENT_LABELS.CONTACT_PAGE, EVENT_CATEGORIES.CONTACT_FLOW)
  }
  phoneClick() {
    this.registerGAEvent(EVENT_NAMES.CLICK_PHONE, EVENT_LABELS.CONTACT_PAGE, EVENT_CATEGORIES.CONTACT_FLOW)
    this.submitCTA?.classList.add('is-disable')
  }
  thanksWhatsappClick() {
    this.registerGAEvent(EVENT_NAMES.CLICK_WHATSAPP, EVENT_LABELS.CHECKOUT_THANKS_PAGE, EVENT_CATEGORIES.USER_FLOW)
  }
  waWidgetSendButtonClick() {
    this.registerGAEvent(EVENT_NAMES.CLICK_WHATSAPP, EVENT_LABELS.WIDGET, EVENT_CATEGORIES.CONTACT_FLOW)
  }
  registerGAEvent(eventName: string, eventLabel: string, eventCategory: string) {
    const payload = {
      event_category: eventLabel,
      event_label: eventCategory
    }
    gaEventTracker(eventName, payload)
  }

  bindEvents() {
    this.emailCTA?.addEventListener('click', () => this.emailClick())
    this.phoneCTA?.addEventListener('click', () => this.phoneClick())
    this.submitCTA?.addEventListener('click', () => this.submitClick())
    this.thanksWhatsappCTA?.addEventListener('click', () => this.thanksWhatsappClick())
    this.waWidgetSendButton?.addEventListener('click', () => this.waWidgetSendButtonClick())
  }
}

document.addEventListener('DOMContentLoaded', function() {
  try {
     new GAEventTracker()
  } catch (e) { }
})
